module.exports = __webpack_public_path__ + "static/linkedin-1a16487e11207c7149403f852aff4834.png";